class UnboundSlider extends HTMLElement {
  connectedCallback() {
    const wrapper = this.querySelector(".images-wrapper");
    const dotsContainer = this.querySelector(".dots");

    if (!wrapper) return;

    const slider = new KeenSlider(wrapper, {
      loop: false,
      slides: {
        perView: 5,
        spacing: 9,
      },
      breakpoints: {
        "(max-width: 749px)": {
          slides: { perView: 2, spacing: 10 },
        },
      },
      created: (s) => {
        if (dotsContainer) this.createDots(s, dotsContainer);
        this.updateArrows(s);
      },
    });

    slider.on("slideChanged", () => {
      this.updateArrows(slider);
      if (dotsContainer) this.updateDots(slider, dotsContainer);
    });

    const prevBtns = document.querySelectorAll(".slider-arrow--prev");
    const nextBtns = document.querySelectorAll(".slider-arrow--next");

    prevBtns.forEach(btn => {
      btn.style.cursor = "pointer";
      btn.style.pointerEvents = "auto";
      btn.setAttribute("tabindex", "0");

      btn.addEventListener("click", () => slider.prev());
    });

    nextBtns.forEach(btn => {
      btn.style.cursor = "pointer";
      btn.style.pointerEvents = "auto";
      btn.setAttribute("tabindex", "0");

      btn.addEventListener("click", () => slider.next());
    });
  }

  updateArrows(slider) {
  const prevBtns = document.querySelectorAll(".slider-arrow--prev");
  const nextBtns = document.querySelectorAll(".slider-arrow--next");

  const details = slider.track.details;
  const current = details.rel;
  const last = details.maxIdx;

  prevBtns.forEach(btn => {
    btn.style.opacity = current === 0 ? "0.4" : "1";
  });

  nextBtns.forEach(btn => {
    btn.style.opacity = current === last ? "0.4" : "1";
  });
}


  createDots(slider, dotsContainer) {
    const pages = slider.track.details.slides.length;
    dotsContainer.innerHTML = "";

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement("button");
      dot.classList.add("dot");
      dot.addEventListener("click", () => slider.moveToIdx(i));
      dotsContainer.appendChild(dot);
    }

    this.updateDots(slider, dotsContainer);
  }

  updateDots(slider, dotsContainer) {
    const dots = dotsContainer.querySelectorAll(".dot");
    if (!dots.length) return;

    const current = slider.track.details.rel % dots.length;

    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === current);
    });
  }
}

if (!customElements.get("unbound-slider")) {
  customElements.define("unbound-slider", UnboundSlider);
}
